module.exports = __webpack_public_path__ + "static/img/mobilefull.19ad4d1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/costumers/Pods/mobilefull.png
// module id = eBqK
// module chunks = 0